import { defineComponent, ref, computed, watchPostEffect, unref, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createVNode, withModifiers, createCommentVNode } from 'vue';
import { OrIconButtonV3 as script$1 } from '../or-icon-button-v3/index.js';
import '../OrAutocompleteV3-8c6de221.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import './index.js';

var TagVariant;
(function (TagVariant) {
  TagVariant["Tag"] = "tag";
  TagVariant["Button"] = "button";
  TagVariant["Reset"] = "reset";
})(TagVariant || (TagVariant = {}));
var TagColor;
(function (TagColor) {
  TagColor["Default"] = "default";
  TagColor["Danger"] = "danger";
})(TagColor || (TagColor = {}));

const Tag = [
// Layout
'layout-inline-row',
// Spacing
'px-sm+ md:px-sm', 'py-sm md:py-xs', 'gap-sm+ md:gap-sm',
// Shape
'rounded-full',
// Typography
'typography-caption-regular whitespace-nowrap'];
const TagVariants = {
  [TagVariant.Tag]: [
  // Interactivity
  'interactivity-select'],
  [TagVariant.Button]: [
  // Interactivity
  'interactivity-click'],
  [TagVariant.Reset]: [
  // Interactivity
  'interactivity-default']
};
const TagColors = {
  [TagColor.Default]: [
  // Theme
  'theme-preset-2-primary', 'dark:theme-preset-2-primary-dark', 'theme-foreground-default', 'dark:theme-foreground-default-dark'],
  [TagColor.Danger]: [
  // Theme
  'theme-preset-2-error', 'dark:theme-preset-2-error-dark']
};

var script = defineComponent({
  name: 'OrTag',
  components: {
    OrIconButton: script$1
  },
  props: {
    variant: {
      type: String,
      default: () => TagVariant.Tag
    },
    color: {
      type: String,
      default: () => TagColor.Default
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'blur', 'reset'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-tag-v3', ...Tag, ...TagVariants[props.variant], ...(!custom.value ? TagColors[props.color] : [])]);
    // State
    const custom = computed(() => {
      return !['default', 'danger'].includes(props.color);
    });
    // Effects
    watchPostEffect(() => {
      const rootElement = unref(root);
      if (rootElement) {
        Object.assign(rootElement.style, {
          backgroundColor: custom.value ? `${props.color}1f` : '',
          color: custom.value ? props.color : ''
        });
      }
    });
    return {
      root,
      rootStyles,
      custom
    };
  }
});

const _hoisted_1 = ["tabindex", "disabled"];
const _hoisted_2 = {
  class: "truncate"
};
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/normalizeClass(['layout-inline-row', '-m-[4px] md:-m-[2px]'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    tabindex: !_ctx.disabled && _ctx.variant === 'button' ? 0 : null,
    disabled: _ctx.disabled,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('click', $event)),
    onFocus: _cache[2] || (_cache[2] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[3] || (_cache[3] = $event => _ctx.$emit('blur', $event))
  }, [createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default")]), _ctx.variant === 'reset' ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(_component_OrIconButton, {
    icon: 'close',
    color: _ctx.custom ? 'inherit' : _ctx.color,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('reset'), ["stop"]))
  }, null, 8 /* PROPS */, ["color", "disabled"])])) : createCommentVNode("v-if", true)], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-tag-v3/OrTag.vue";

export { script as OrTagV3, TagColor, TagVariant };
